/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScreeningFlowTestEntitySelection
 */
export interface InternalApiScreeningFlowTestEntitySelection {
    /**
     * 
     * @type {InternalApiScreeningFlowTestEntitySelectionModeEnum}
     * @memberof InternalApiScreeningFlowTestEntitySelection
     */
    mode: InternalApiScreeningFlowTestEntitySelectionModeEnum;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestEntitySelection
     */
    fromTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestEntitySelection
     */
    toTime?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlowTestEntitySelection
     */
    entityIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScreeningFlowTestEntitySelectionModeEnum {
    DATE_RANGE = 'DATE_RANGE',
    ENTITY_IDS = 'ENTITY_IDS'
}


/**
 * Check if a given object implements the InternalApiScreeningFlowTestEntitySelection interface.
 */
export function instanceOfInternalApiScreeningFlowTestEntitySelection(value: object): value is InternalApiScreeningFlowTestEntitySelection {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowTestEntitySelectionFromJSON(json: any): InternalApiScreeningFlowTestEntitySelection {
    return InternalApiScreeningFlowTestEntitySelectionFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestEntitySelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowTestEntitySelection {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'fromTime': json['fromTime'] == null ? undefined : (new Date(json['fromTime'])),
        'toTime': json['toTime'] == null ? undefined : (new Date(json['toTime'])),
        'entityIds': json['entityIds'] == null ? undefined : json['entityIds'],
    };
}

export function InternalApiScreeningFlowTestEntitySelectionToJSON(json: any): InternalApiScreeningFlowTestEntitySelection {
    return InternalApiScreeningFlowTestEntitySelectionToJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestEntitySelectionToJSONTyped(value?: InternalApiScreeningFlowTestEntitySelection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': value['mode'],
        'fromTime': value['fromTime'] == null ? value['fromTime'] : value['fromTime'].toISOString(),
        'toTime': value['toTime'] == null ? value['toTime'] : value['toTime'].toISOString(),
        'entityIds': value['entityIds'],
    };
}

